import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useLocation, useHistory } from 'react-router-dom';
import { Loading } from 'react-style-guide';
import bedev2Services from '../common/services/bedev2Services';
import SortDetailV2DiscoveyApi from './discoveryApi/SortDetailV2DiscoveryApi';
import SortDetailV2GamesApi from './gamesApi/SortDetailV2GamesApi';
import eventStreamConstants from '../common/constants/eventStreamConstants';
import usePageReferralTracker from '../common/hooks/usePageReferralTracker';
import experimentConstants from '../common/constants/experimentConstants';

const { layerNames, defaultValues } = experimentConstants;

export const SortDetailV2 = ({ match }: RouteComponentProps<{ sortName: string }>): JSX.Element => {
  const sortName = decodeURIComponent(match.params.sortName);
  const [discoveryApiEnabled, setDiscoveryApiEnabled] = useState<boolean | undefined>(undefined);
  const location = useLocation();
  const history = useHistory();

  usePageReferralTracker(
    eventStreamConstants.sortDetailReferral,
    ['position', 'homePageSessionInfo', 'sortId', 'page', 'treatmentType'],
    [],
    location,
    history
  );

  const fetchExperimentValues = async () => {
    const data = await bedev2Services.getExperimentationValues(
      layerNames.homePage,
      defaultValues.homePage
    );
    setDiscoveryApiEnabled(data.IsDiscoveryApiEnabled);
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchExperimentValues();
  }, []);

  if (discoveryApiEnabled === false) {
    return <SortDetailV2GamesApi sortName={sortName} />;
  }

  if (discoveryApiEnabled === true) {
    return <SortDetailV2DiscoveyApi sortName={sortName} />;
  }

  return <Loading />;
};

export default SortDetailV2;
